
import { defineComponent, ref } from 'vue'
import { getPortalConfigFromNuxeo } from '@/composables/nuxeo'
import { PortalConfigFromNuxeoResponse } from './contracts/api/ResponseContracts'

export default defineComponent(
   {
      name: 'Notice',
      setup()
      {
         const noticeVisible = ref(false)
         const title = ref('')
         const message = ref('')

         getPortalConfigFromNuxeo(function(response: PortalConfigFromNuxeoResponse)
         {
            noticeVisible.value = response.isNoticeEnabled
            title.value = response.noticeTitle
            message.value = response.noticeMessage
         })

         return {
            noticeVisible,
            title,
            message
         }
      }

   })
